import { render, staticRenderFns } from "./PersonalDetails.vue?vue&type=template&id=8440e3d6&scoped=true&"
import script from "./PersonalDetails.vue?vue&type=script&lang=ts&"
export * from "./PersonalDetails.vue?vue&type=script&lang=ts&"
import style0 from "./PersonalDetails.vue?vue&type=style&index=0&id=8440e3d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8440e3d6",
  null
  
)

export default component.exports